import { inject, Injectable } from '@angular/core';
import { User } from '../models/User';
import { GenericService } from './generic.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class UserService extends GenericService<User> {
  private internalHttp = inject(HttpClient);
  constructor() {
    super();
    this.setContext('users');
  }

  findByEmail(email: string): Observable<User> {
    return this.internalHttp.get<User>(
      `${environment.apiUrl}/${this.context}/findByEmail/${email}`
    );
  }

  findByUsername(username: string): Observable<User> {
    return this.internalHttp.get<User>(
      `${environment.apiUrl}/${this.context}/findByUsername/${username}`
    );
  }

  reactivateUser(id: number): Observable<User> {
    return this.internalHttp.get<User>(
      `${environment.apiUrl}/${this.context}/reactivateUser/${id}`
    );
  }
}
